import Alpine from "../alpine.js"
import { client } from "../client.js"

Alpine.data("assessmentScreenWizard", ({ step, stepCount, updateUrl }) => ({
  step,
  stepCount,
  updateUrl,
  batchUpdate: false,
  updateValue (value, name) {
    if (this.batchUpdate === false) {
      client.put(this.updateUrl, { results: { data: { name, value }}})
        .then((response) => {
          this.$dispatch("assessment-value-updated", response)
        })
        .catch((error) => { console.log({ error }) })
    }
  },
  batchUpdateNodes (nodeList) {
    this.batchUpdate = true

    let results = {}
    for (let i = 0; i < nodeList.length; i++) {
      // I can't figure out how to make the UI work without clicking all the things
      nodeList[i].click()

      let node = nodeList[i]
      results[i] = {
        name: node.dataset.name,
        value: node.value
      }
    }

    client.put(this.updateUrl, { results })
      .then((response) => {
        this.$dispatch("assessment-value-updated", response)
      })
      .catch((error) => { console.log({ error }) })

    this.batchUpdate = false
  },
  next () {
    if ((this.step + 1) > this.stepCount) {
      this.$dispatch("assessment-screen-complete")
    } else {
      this.step = this.step + 1
    }

    this.$nextTick(() => { window.scrollTo({ top: 0, behavior: 'smooth' }) })
  },
  prev () {
    if (this.step > 1) {
      this.step = this.step - 1
    } else {
      this.$dispatch("assessment-screen-cancel")
    }

    this.$nextTick(() => { window.scrollTo({ top: 0, behavior: 'smooth' }) })
  }
}))
